// Wrappers para /api/reports/*.

import { apiFetch } from './api';

export interface ReportFilters {
  from?: string;       // YYYY-MM-DD
  to?: string;
  company_id?: number;
  teacher_id?: number;
  type?: 'one' | 'gr';
  tracking_status_id?: number;
  student_id?: number;
  page?: number;
  page_size?: number;
}

export interface ReportSession {
  booking_id: number;
  type: 'one' | 'gr';
  scheduled_at: string;
  duration_min: number;
  status: 'scheduled' | 'cancelled' | 'completed' | 'no_show';
  teacher_id: number;
  teacher_name: string;
  cohort_id: number | null;
  cohort_name: string | null;
  company_ids: string | null;
  student_ids: string;
  student_names: string;
  present_count: number;
  absent_count: number;
  canceled_count: number;
  classroom_id: number | null;
  classroom_state: 'open' | 'closed' | null;
}

export interface ReportStudent {
  student_id: number;
  email: string;
  display_name: string;
  license_slug: string | null;
  level_slug: string | null;
  level_label: string | null;
  company_ids: string | null;
  total_sessions: number;
  present_count: number;
  absent_count: number;
  canceled_count: number;
  total_minutes_attended: number;
}

export interface ReportStudentSession {
  booking_id: number;
  scheduled_at: string;
  duration_min: number;
  type: 'one' | 'gr';
  teacher_name: string;
  status: string;
  joined_at: string | null;
  left_at: string | null;
  tracking_status_slug: string | null;
  duration_attended_min: number | null;
}

function toQuery(filters: ReportFilters): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  }
  return params.toString() ? `?${params.toString()}` : '';
}

export async function listSessions(filters: ReportFilters): Promise<{ items: ReportSession[]; total: number; page: number; page_size: number }> {
  const r = await apiFetch<{ status: 'ok'; items: ReportSession[]; total: number; page: number; page_size: number }>(`/reports/sessions${toQuery(filters)}`);
  return { items: r.items, total: r.total, page: r.page, page_size: r.page_size };
}

export async function listStudents(filters: ReportFilters): Promise<ReportStudent[]> {
  const r = await apiFetch<{ status: 'ok'; items: ReportStudent[] }>(`/reports/students${toQuery(filters)}`);
  return r.items;
}

export async function getStudentTracking(studentId: number, filters: ReportFilters = {}): Promise<ReportStudentSession[]> {
  const r = await apiFetch<{ status: 'ok'; items: ReportStudentSession[] }>(`/reports/students/${studentId}/tracking${toQuery(filters)}`);
  return r.items;
}

// Descarga directa del XLSX usando fetch nativo (no JSON).
export async function downloadSessionsXlsx(filters: ReportFilters): Promise<void> {
  const url = `/api/reports/sessions/export.xlsx${toQuery(filters)}`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`Export failed (${res.status})`);
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `informe_${filters.from ?? 'todo'}_${filters.to ?? 'todo'}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}
